import { toast } from 'react-toastify';

const useToast = () => {
  const showSuccess = (message) => toast.success(message);
  const showError = (message) => toast.error(message);
  const showWarning = (message) => toast.warning(message);

  return {
    toasts: [], // Kept for backwards compatibility if some components still map over it
    removeToast: () => {},
    showSuccess,
    showError,
    showWarning
  };
};

export default useToast;
